import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const isLoadingSelector = (statusKey) => (state) => state.fileUpload[statusKey] === REDUX_ASYNC_STATUSES.LOADING;

export const selectUploadsTempContainer = (state) => state.fileUpload?.uploadsTempContainer;
export const selectFileUploadLoading = isLoadingSelector('fileUploadStatus');
export const selectFileUploadMessageAttachmentLoading = isLoadingSelector('fileUploadMessageAttachmentStatus');
